module.exports = __webpack_public_path__ + "img/pernille.7f98dd5d.png";